import { useTranslation } from "react-i18next"
import { Button, Input } from "components"
import { Box } from "theme-ui"

export const RevisionSystem = () => {
 // language translator
 const { t } = useTranslation("translation")
 return (
  <div className="pt-7 w-[96%] mx-auto">
   <h1 className="font-semibold Jakarta-font pb-3">{t("enterRevision")}</h1>
   <Box bg="light_gray" color="text-black">
    <ul className="flex w-full flex-wrap overflow-x-auto whitespace-nowrap Jakarta-font py-2">
     <li className="text-xs opacity-70 cursor-pointer  px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">STm.5</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">STm.6</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">Testanglag 01</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">Testanglag 01 Copy</a>
     </li>
     <li className="text-xs opacity-70 cursor-pointer px-2 lg:px-4 md:px-4 whitespace-nowrap">
      <a href="/">UCM-Test</a>
     </li>
    </ul>
   </Box>

   <Box bg="highlight" color="text-black" className="px-4">
    <h1 className="font-semibold Jakarta-font py-4">{t("enterRevision")}</h1>
    <div className="flex justify-between ">
     <div className="flex flex-col justify-center w-[32%]">
      <Input
       label={`${"begin"}:`}
       id="begin"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[32%]">
      <Input
       label={`${"end"}:`}
       id="end"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="date"
      />
     </div>
     <div className="flex flex-col justify-center w-[32%]">
      <Input
       label={`${t("duration")} [m]:`}
       id="length"
       className="bg-gray py-2 outline-none rounded px-2 text-black"
       type="number"
      />
     </div>
    </div>
    <div className="flex flex-col justify-center w-full pt-2">
     <Input
      label={`${t("remarks")}:`}
      id="remark"
      className="bg-gray py-2 outline-none rounded px-2 text-black"
      type="text"
      placeholder={`${t("enterHere")}...`}
     />
    </div>
    <div className="flex flex-col justify-center w-full pt-2">
     <Input
      label={`${t("reasons")}:`}
      id="reason"
      className="bg-gray py-2 outline-none rounded px-2 text-black"
      type="text"
      placeholder={`${t("enterHere")}...`}
     />
    </div>
    <div className="flex flex-col justify-center w-full pt-2">
     <Input
      label={`${t("Sonstiges")}:`}
      id="miscellaneous"
      className="bg-gray py-2 outline-none rounded px-2 text-black"
      type="text"
      placeholder={`${t("enterHere")}...`}
     />
    </div>
    <div className="flex justify-end py-4">
     <div className="w-full-">
      {" "}
      <Button size={"lg"}>{t("carryOut")}</Button>
     </div>
    </div>
   </Box>
  </div>
 )
}
